import {memo, useMemo, useCallback} from 'react';
import {StyleSheet, View, FlatList} from 'react-native';
import Styles from '../../Styles';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import {IsConnectedProps} from 'src/types/Screen';
import ScanAndPayLocationView from 'src/components/elements/home/ScanAndPayLocationView';
import {getDescriber} from './descriptor/DescriptorType';

type ScanAndPayLocation = {
  location: CampusLocationType;
  isCoffeeMachine: boolean;
};

type ScanAndPayLocationsListProps = IsConnectedProps & {
  locations: CampusLocationType[];
  coffeeLocations: CampusLocationType[];
  onLocationClick: (
    machine: CampusLocationType,
    autoAdvanced?: boolean,
  ) => Promise<void>;
  scrollEnabled?: boolean;
  isUnSupportedLocation?: boolean;
};

const {getScanAndPayTile, getScanAndPayMismatchLocationError} = getDescriber();

const ScanAndPayLocationsList = memo((props: ScanAndPayLocationsListProps) => {
  //Returns Scan And Pay Location Item UI
  const locationList = useMemo<ScanAndPayLocation[]>(() => {
    return [
      ...props.locations.map((loc) => ({
        location: loc,
        isCoffeeMachine: false,
      })),
      ...props.coffeeLocations.map((loc) => ({
        location: loc,
        isCoffeeMachine: true,
      })),
    ];
  }, [props.locations, props.coffeeLocations]);

  const renderItem = useCallback(
    ({item}: {item: ScanAndPayLocation}) => (
      <ScanAndPayLocationView
        location={item.location}
        onLocationClick={props.onLocationClick}
        isCoffeeMachine={item.isCoffeeMachine}
      />
    ),
    [props.onLocationClick],
  );

  const renderHeaderItem = useCallback(() => {
    if (props.isUnSupportedLocation) {
      return (
        <View style={styles.listHeader}>
          {getScanAndPayMismatchLocationError()}
        </View>
      );
    }
    return null;
  }, [props.isUnSupportedLocation]);

  return (
    <View style={[styles.container, getScanAndPayTile()['listContainer']]}>
      <FlatList
        renderItem={renderItem}
        ListHeaderComponent={renderHeaderItem}
        style={styles.scanAndPayLocationListView}
        scrollEnabled={props.scrollEnabled ?? false}
        data={locationList}
        keyExtractor={(item, index) => `${item?.location?.locationId}-${index}`}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'flex-start',
    marginBottom: Styles.Spacing.m1,
    justifyContent: 'flex-start',
  },
  scanAndPayLocationListView: {
    width: '100%',
  },
  listHeader: {
    marginHorizontal: Styles.Spacing.m4,
  },
});

export default ScanAndPayLocationsList;
